import Button from 'components/Button';
import Panel from 'components/Panel';
import {FC} from 'react';
import {jt, t} from 'ttag';
import analyticsTrack from 'utils/analytics';

import bizpayLogo from './bizpay_logo.png';

interface BizpayPanelProps {
    bizpayAffiliateUrl: string;
}

const BizpayPanel: FC<BizpayPanelProps> = ({bizpayAffiliateUrl}) => {
    const img = (
        <img
            alt="bizpay"
            className="ml-2"
            key="0"
            src={bizpayLogo}
            width="100px"
        />
    );
    return (
        <Panel title={t`Pay invoice by credit card`}>
            <div className="flex flex-col gap-y-2">
                <div>{t`Company or sole proprietor? Pay bank transfer invoices by credit card using one of our partners.*`}</div>
                <Button
                    aria-label="pay"
                    className="w-full"
                    kind="secondary"
                    onClick={() =>
                        analyticsTrack('clicked go to bizpay', 'Application', {
                            isBlank: true,
                            url: bizpayAffiliateUrl,
                        })
                    }
                    size="base"
                >
                    <div className="flex items-center justify-center">
                        {jt`Go to ${img}`}
                    </div>
                </Button>
                <div className="text-xs text-grey-500">
                    {t`* Requires registration and approval by the third-party service.`}
                </div>
            </div>
        </Panel>
    );
};

export default BizpayPanel;
